export default __webpack_public_path__ + "static/media/binance-logo.ca40e468.png";